// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'S-a mutat ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) =>
    'Acţiunea pt. ' + p['label'] + ' s-a finalizat',
  accButtonProgressStatus: (p: { label: string }) => 'Acţiunea pt. ' + p['label'] + ' este în curs',
  accColorPalette: () => 'Paletă de culori',
  accColorSwatch: () => 'Selector de culori',
  accCommandKey: () => 'Comandă',
  accContextMenuLabel: () => 'acţiuni',
  accControlKey: () => 'Închidere',
  accPositionAfter: () => 'după',
  accPositionBefore: () => 'înainte de',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Ţineţi apăsate tastele ' +
    p['keyPressed'] +
    ' şi Shift, apoi utilizaţi tastele cu săgeţi pentru a reordona.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Introduceţi o dată completă, în acest format: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Introduceţi luna şi anul, în acest format: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Etichetă',
  chart_labelGroup: () => 'Grup',
  chart_labelSeries: () => 'Serie',
  chart_labelValue: () => 'Valoare',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Selectaţi o valoare.',
  checkbox_helpForCheckbox: () => 'Asistenţă pentru caseta de validare',
  checkbox_requiredMessageDetail: () => 'Selectaţi o valoare.',
  checkbox_selected: () => 'Casetă de validare bifată',
  checkbox_unselected: () => 'Casetă de validare nebifată',
  close: () => 'Închidere',
  collection_apply: () => 'Aplicare',
  collection_cancel: () => 'Anulare',
  collection_loaded: () => 'Încărcată',
  collection_loading: () => 'Se încarcă',
  collection_noData: () => 'Nu există date de afişat.',
  collection_pixels: () => 'px',
  collection_resizeColumnDialog: () => 'Redimensionare coloană',
  collection_resizeColumnMenu: () => 'Redimensionare coloană...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Introduceţi un număr între ' + p['MIN'] + ' şi ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Selectare toate rândurile',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Selectaţi rândul ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'În ordine crescătoare',
  collection_sortColumnMenu: () => 'Sortare coloană',
  collection_sortDescendingSubMenu: () => 'În ordine descrescătoare',
  collection_sortDisabled: () => 'Nu permite sortarea',
  collection_sortEnabled: () => 'Permite sortarea',
  collection_width: () => 'Lăţime',
  colorPicker_label: () => 'Selector de culori',
  confirmation: () => 'Confirmare',
  datePicker_currentDate: () => 'Data curentă',
  datePicker_goToToday: () => 'Deplasare la ziua curentă',
  datePicker_label: () => 'Selector de dată',
  datePicker_month: () => 'Lună',
  datePicker_months: () => 'Luni ',
  datePicker_next: () => 'Înainte',
  datePicker_nextDecade: () => 'Următoarea decadă',
  datePicker_nextMonth: () => 'Luna următoare',
  datePicker_prev: () => 'Înapoi',
  datePicker_prevDecade: () => 'Decada anterioară',
  datePicker_prevMonth: () => 'Luna precedentă',
  datePicker_restricted: () => 'Restricţionat',
  datePicker_selected: () => 'Selectată',
  datePicker_today: () => 'Astăzi',
  datePicker_weekNum: (p: { NUM: string }) => 'Săptămâna ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Nr. săptămână',
  datePicker_year: () => 'An',
  datePicker_years: () => 'Ani',
  diagram_promotedLink: () => '1 link',
  diagram_promotedLinkAriaDesc: () => 'Indirect',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' legături',
  error: () => 'Eroare',
  expandableList_expandCollapseInstructionText: () =>
    'Utilizaţi tastele cu săgeţi pt. a extinde şi a restrânge',
  expandableList_groupCollapse: () => 'Restrâns',
  expandableList_groupExpand: () => 'Extins',
  filePicker_addFiles: () => 'Adăugare fişiere',
  filePicker_dropzonePrimaryText: () => 'Glisare şi plasare',
  filePicker_dropzoneSecondaryText: () => 'Selectaţi un fişier sau plasaţi unul aici',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selectaţi fişiere sau plasaţi-le aici',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nu puteţi încărca fişiere de tip: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Încărcaţi doar câte un fişier',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nu puteţi încărca fişiere de tip ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'necunoscut',
  formControl_clear: () => 'Golire',
  formControl_day: () => 'Zi',
  formControl_empty_segment: () => 'Necompletat',
  formControl_helpAvailable: () => 'Asistenţă disponibilă',
  formControl_hide: () => 'Ascundere ',
  formControl_hour: () => 'Oră',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Aţi atins limita de ' +
    ((
      {
        one: new Intl.NumberFormat('ro').format(p['CHARACTER_LIMIT']) + ' caracter',
        few: new Intl.NumberFormat('ro').format(p['CHARACTER_LIMIT']) + ' caractere'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('ro').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('ro').format(p['CHARACTER_LIMIT']) + ' caractere') +
    '.',
  formControl_loading: () => 'Se încarcă',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Puteţi introduce până la ' + p['MAX_LENGTH'] + ' caractere.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'S-a depăşit lungimea maximă, de ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caractere rămase.',
  formControl_millisecond: () => 'Milisecundă',
  formControl_minute: () => 'Minut',
  formControl_month: () => 'Lună',
  formControl_readOnly: () => 'Read-only',
  formControl_requiredMessageDetail: () => 'Introduceţi o valoare.',
  formControl_second: () => 'Secundă',
  formControl_selectionExactMessageDetail: (p: { n: string }) => 'Selectaţi ' + p['n'] + ' valori.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Aţi atins limita de ' + p['max'] + ' selecţii.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Selectaţi între ' + p['min'] + ' şi ' + p['max'] + ' valori.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Selectaţi cel puţin ' + p['min'] + ' valori.',
  formControl_show: () => 'Afişare ',
  formControl_year: () => 'An',
  gantt_labelDate: () => 'Dată',
  gantt_labelEnd: () => 'Sfârşit',
  gantt_labelLabel: () => 'Etichetă',
  gantt_labelRow: () => 'Rând',
  gantt_labelStart: () => 'Început',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nu s-a găsit nicio secţiune care să corespundă.',
  indexer_keyboardInstructionText: () => 'Apăsaţi Enter pt. a selecta valoarea.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Între ' + p['FROM_SECTION'] + ' şi ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Atingeţi de două ori şi menţineţi apăsat pt. a intra în modul Gesturi, apoi glisaţi în sus sau în jos pt. a ajuta valoarea.',
  info: () => 'Informaţii',
  inputColor_selectColor: () => 'Selectaţi o culoare',
  inputDateMask_date_cleared: () => 'Data golirii',
  inputDateMask_dayPlaceholder: () => 'zz',
  inputDateMask_empty_segment: () => 'Necompletat',
  inputDateMask_monthPlaceholder: () => 'll',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Introduceţi o dată care să coincidă cu sau să fie anterioară datei de ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Introduceţi o dată care să coincidă cu sau să fie ulterioară datei de ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Introduceţi o dată disponibilă.',
  inputDatePicker_instruction: () => 'Apăsaţi tasta Tab pt. a accesa calendarul.',
  inputDatePicker_selectDate: () => 'Selectaţi o dată',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Introduceţi o lună şi un an care să fie ' + p['max'] + ' sau anterioare acestei date.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Introduceţi o lună şi un an care să fie ' + p['min'] + ' sau ulterioare acestei date.',
  inputNumber_converterParseError: () => 'Introduceţi un număr.',
  inputNumber_decrease: () => 'Scădere',
  inputNumber_increase: () => 'Creştere',
  inputPassword_hidden: () => 'Parolă ascunsă',
  inputPassword_hide: () => 'Ascundere parolă',
  inputPassword_show: () => 'Afişare parolă',
  inputSensitiveText_hidden: () => 'Text confidenţial ascuns',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Introduceţi o oră care să fie ' + p['max'] + ' sau o oră anterioară.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Introduceţi o oră care să fie ' + p['min'] + ' sau o oră ulterioară.',
  inputTimeMask_time_cleared: () => 'Ora golirii',
  labelNone: () => 'Nimic',
  list_msgFetchCompleted: () => 'Încărcată',
  list_msgFetchingData: () => 'Se încarcă',
  list_suggestion: () => 'Sugestie',
  menu_stateLoading: () => 'Se încarcă',
  messageToast_allMessagesClosed: () => 'Toate mesajele de alertă sunt închise.',
  message_close: () => 'Închidere',
  message_confirmation: () => 'Reuşită',
  message_error: () => 'Eroare',
  message_info: () => 'Informaţii',
  message_navigationFromMessagesRegion: () =>
    'Se intră în regiunea Mesaje. Apăsaţi F6 pentru a naviga.',
  message_navigationToMessagesRegion: () =>
    'În regiunea Mesaje există mesaje noi. Apăsaţi F6 pt. a naviga la acestea.',
  message_navigationToTouch: () => 'În regiunea Mesaje există mesaje noi.',
  message_warning: () => 'Avertisment',
  noData_message: () => 'Nu există niciun element de afişat',
  overflowItemLabel: () => 'Mai multe file',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Atingeţi de 2 ori pt. a închide pop-upul deschis.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Se intră în pop-up. Apăsaţi F6 pt. a naviga între pop-up şi controlul asociat.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Pop-upul a fost deschis. Apăsaţi F6 pt. a naviga între pop-up şi controlul asociat.',
  progressIndeterminate: () => 'În curs',
  radioButton_checked: () => 'Butonul radio este bifat',
  radioButton_selected: () => 'Butonul radio este selectat',
  radioButton_unchecked: () => 'Butonul radio nu este bifat',
  radioButton_unselected: () => 'Butonul radio nu este selectat',
  radio_helpForRadio: () => 'Asistenţă pentru buton radio',
  radio_requiredMessageDetail: () => 'Selectaţi o valoare.',
  selectMultiple_apply: () => 'Aplicare',
  selectMultiple_back: () => 'Înapoi',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Utilizaţi săgeţile stânga şi dreapta pt. a evidenţia valorile selectate.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Apăsaţi pe Backspace sau Delete pentru a elimina valoarea selectată.',
  selectMultiple_selectedValues: () => 'Valori selectate',
  selectMultiple_showSelectedValues: () => 'Afişaţi doar valorile selectate.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valori selectate.',
  select_addToList: () => 'Adăugare în listă',
  select_addToListAvailable: () => 'Adăugare în lista disponibilă',
  select_closeDropdown: () => 'Apăsaţi Escape pentru a închide.',
  select_moreSearchOptions: () => 'Mai multe opţiuni de căutare',
  select_moreSearchOptionsAvailable: () => 'Mai multe opţiuni de căutare disponibile',
  select_noMatchesFound: () => 'Nu s-a găsit niciun rezultat.',
  select_oneMatchFound: () => 'S-a găsit un rezultat.',
  select_requiredMessageDetail: () => 'Selectaţi o valoare.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'S-au găsit ' + p['TOTAL_SIZE'] + ' rezultate',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'S-au găsit ' + p['TOTAL_SIZE'] + ' sau mai multe rezultate',
  selectorAll_deselectAll: () => 'Deselectare toate',
  selectorAll_selectAll: () => 'Selectare globală',
  selector_selected: () => 'Casetă de validare bifată',
  selector_unselected: () => 'Casetă de validare nebifată',
  sheet_close: () => 'Închidere',
  switch_off: () => 'Dezactivat',
  switch_on: () => 'Activare',
  tabBarNavigationList_removeCueText: () => 'Poate fi eliminat',
  tabBar_tabContainsErrors: () => 'Conţine erori',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'S-a eliminat ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'are meniu contextual',
  tabbar_labelMoveLeft: () => 'Mutare la stânga',
  tabbar_labelMoveRight: () => 'Mutare la dreapta',
  tabbar_labelRemove: () => 'Eliminare',
  timeComponent_tooltipZoomIn: () => 'Mărire',
  timeComponent_tooltipZoomOut: () => 'Micşorare',
  timeConverter_parseError: () => 'Introduceţi o oră completă.',
  train_current: () => 'Curentă',
  train_message_type: () => 'Tip mesaj',
  train_not_visited: () => 'Nevizitată',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Etapa ' + p['currentStep'] + ' din ' + p['numberOfSteps'],
  train_visited: () => 'Vizitată',
  userAssistance_learnMore: () => 'Mai multe informaţii',
  userAssistance_required: () => 'Obligatoriu',
  vis_clearSelection: () => 'Golire selecţie',
  vis_drillable: () => 'Permite detalierea',
  vis_invalidData: () => 'Date nevalide',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' din ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Selectare cadru de selecţie',
  vis_marqueeZoomTooltip: () => 'Zoom cadru de selecţie',
  vis_noData: () => 'Nu există date de afişat',
  vis_panTooltip: () => 'Panoramare',
  vis_stateCollapsed: () => 'Restrâns',
  vis_stateExpanded: () => 'Extins',
  vis_stateLoaded: () => 'Încărcată',
  vis_stateLoading: () => 'Se încarcă',
  vis_stateSelected: () => 'Selectată',
  vis_stateUnselected: () => 'Neselectată',
  warn: () => 'Avertisment'
};
export default bundle;
